import React, { ButtonHTMLAttributes } from 'react';
import styled from '@xstyled/styled-components';
import Icon from '~/assets/icons/thumbs-up-down.svg';
import { t } from 'ttag';
import { jumpAnimation } from '~/ui/animation';

const StyledIcon = styled(Icon)`
  width: 32px;
  height: 27px;
`;

const Button = styled.button`
  background: ${p => p.theme.colors.overlayMed};
  width: 35px;
  height: 35px;
  border-radius: 17.5px;
  border: none;
  color: ${p => p.theme.colors.white};
  font-family: ${p => p.theme.fonts.title};
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover > svg {
    animation: ${jumpAnimation('0px', '-4px', '0px')} 0.7s linear infinite;
  }
  padding: 0px;
  @media ((max-width: 580px) and (max-height: 300px)) {
    width: 25px;
    height: 25px;
  }
`;

export const ThumbsButton = React.forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(({ ...props }, ref) => (
  <Button {...props} ref={ref} aria-label={t`Feedback`} aria-haspopup="dialog">
    <StyledIcon aria-hidden="true" focusable="false" />
  </Button>
));

ThumbsButton.displayName = 'ThumbsButton';
